import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';
import { FaArrowRight } from 'react-icons/fa';

const brands = [
  {
    name: "Quick Lending",
    imageUrl: "/img/ql_logo.png",
    link: "https://quicklendingusa.net/",
  },
  {
    name: "Atlas Solutions",
    imageUrl: "/img/atlasSolutions.png",
    link: "https://atlassolutionsmarketing.com/",
  },
  {
    name: "VIP Home Loans",
    imageUrl: "/img/viphomeloans.png",
    link: "https://viphomeloans.net/",
  },
  {
    name: "Construction Depot",
    imageUrl: "/img/cd.png",
    link: "https://constructiondepotusa.com/",
  },
  {
    name: "JP Capital",
    imageUrl: "/img/JPC-.png",
    link: "https://jpcapitalusa.com/",
  },
  {
    name: "My Virtual Assistant",
    imageUrl: "/img/MVA.png",
    link: "https://myvirtualassistantusa.com/",
  },
  {
    name: "Quick Lending Deluxe",
    imageUrl: "/img/QLDeluxe.png",
    link: "https://quicklendingdeluxe.com/",
  },
  {
    name: "The Tax Advisor",
    imageUrl: "/img/TheTaxAdvisor.png",
    link: "https://thetaxadvisor.net/",
  },
  {
    name: "My Processing Team",
    imageUrl: "/img/mpt.png",
    link: "https://example.com/myprocessingteam",
  },
  {
    name: "Flowers of Central Florida",
    imageUrl: "/img/Flowers.png",
    link: "https://example.com/flowers",
  }
];

const LandingPage = () => {
  return (
    <div className={styles.container}>
      {/* Dynamic Animated Branch Background SVG */}
      <div className={styles.branchBackground}>
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none" className={styles.svgBranch}>
          <g className={styles.branchesGroup}>
            {/* Main Trunk & Main Branches */}
            <path className={`${styles.branch} ${styles.branch1}`} d="M300,1000 C350,700 300,400 200,0" />
            <path className={`${styles.branch} ${styles.branch2}`} d="M300,700 C400,500 450,300 500,0" />
            <path className={`${styles.branch} ${styles.branch3}`} d="M350,850 C450,800 550,600 700,0" />
            <path className={`${styles.branch} ${styles.branch4}`} d="M500,1000 C500,800 550,600 650,400 C700,300 800,150 900,0" />
            
            {/* Secondary Branches */}
            <path className={`${styles.branch} ${styles.branch5}`} d="M315,550 C280,450 200,200 100,0" />
            <path className={`${styles.branch} ${styles.branch6}`} d="M425,400 C450,300 480,200 470,0" />
            <path className={`${styles.branch} ${styles.branch7}`} d="M500,650 C600,550 750,450 950,200" />
            <path className={`${styles.branch} ${styles.branch8}`} d="M600,850 C700,750 850,700 1000,500" />
          </g>
        </svg>
      </div>

      {/* Background glow over branches */}
      <div className={styles.glowTop}></div>
      <div className={styles.glowBottom}></div>

      <nav className={styles.navbar}>
        <div className={styles.navLogo}>
          <img src="/img/logo-blanco-AI.png" alt="Atlas Investments" />
        </div>
        <Link to="/login" className={styles.loginBtn}>
          Employee Portal <FaArrowRight className={styles.icon} />
        </Link>
      </nav>

      <main className={styles.mainContent}>
        <header className={styles.header}>
          <h1 className={styles.title}>
            Welcome to <span className={styles.highlight}>Atlas Investments</span>
          </h1>
          <p className={styles.subtitle}>
            Empowering growth across multiple sectors. Discover our ecosystem of industry-leading brands.
          </p>
        </header>

        <section className={styles.brandsSection}>
          <div className={styles.brandsGrid}>
            {brands.map((brand, index) => (
              <a 
                key={index}
                href={brand.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.brandCard}
              >
                <div className={styles.cardGlow}></div>
                <div className={styles.cardContent}>
                  <div className={styles.imageContainer}>
                    <img src={brand.imageUrl} alt={brand.name} className={styles.brandImage} />
                  </div>
                  <h3 className={styles.brandName}>{brand.name}</h3>
                </div>
              </a>
            ))}
          </div>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Atlas Investments. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
